import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ResponseError } from '@sgi/gravity/ResponseError';
import { Typography } from '@sgi/gravity/Typography';
import React from 'react';
/**
 * Generic error boundary component.
 */
export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
        };
    }
    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            error: error,
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error(error, errorInfo);
    }
    render() {
        if (this.state.hasError) {
            if (this.state.error['response'] && this.state.error['response']['data']) {
                const errorDetails = this.state.error['response']['data'];
                return (_jsxs(ResponseError, { errorCode: errorDetails.errorCode, errorDescription: errorDetails.description, title: "Something went wrong!", children: [_jsx(Typography, { children: errorDetails.description }), typeof errorDetails.data === 'object' ? _jsx("pre", { children: JSON.stringify(errorDetails.data, null, 1) }) : errorDetails.data, ";"] }));
            }
            else if (this.state.error?.message) {
                return (_jsxs(React.Fragment, { children: [_jsx(Typography, { children: this.state.error.message }), _jsx(Typography, { children: this.state.error.stack })] }));
            }
            return 'An error has occurred.';
        }
        return this.props.children;
    }
}
